import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { DEG_TO_RAD, Point, RAD_TO_DEG, Sprite } from "pixi.js";
import tools from "tools";
export default class ClickParticles {
  constructor(tint, center, nbr, particulesContainer, radius, scale) {
    this._particulesContainer = particulesContainer;
    this._particulesArr = [];
    this._center = center;
    this.__gravity = new Point(0, 0);
    this._radius = radius;
    this._pos = null;
    this._angle = 0;
    let texture = assets.textures.frag0.texture;
    for (let i = 0; i < nbr; i++) {
      const particule = new Sprite(texture);
      particule.anchor.set(.5);
      particule.scale.x = .7 * scale;
      particule.scale.y = .1 * scale;
      particule.tint = tint;
      particule.rotation = Math.random() * 360 * DEG_TO_RAD;
      particule.radius = 0;
      particule.radiusMax = this._radius * tools.range(.3, 1);
      this._particulesContainer.addChild(particule);
      gsap.to(particule.scale, {
        duration: .5,
        y: scale
      });
      gsap.to(particule, {
        delay: tools.range(0, .1),
        duration: .2,
        radius: particule.radiusMax,
        onUpdate: p => {
          let pos = tools.angle2pos({
            x: 0,
            y: 0
          }, p.radius, p.rotation * RAD_TO_DEG - 90);
          p.x = pos.x + this._center.x;
          p.y = pos.y + this._center.y;
        },
        onUpdateParams: [particule],
        onComplete: p => {
          let pos = tools.angle2pos({
            x: 0,
            y: 0
          }, p.radius + 10, p.rotation * RAD_TO_DEG - 90);
          gsap.to(p, {
            duration: .5,
            x: pos.x + this._center.x,
            y: pos.y + this._center.y
          });
          gsap.to(p.scale, {
            delay: tools.range(0, .2),
            duration: .5,
            x: 0,
            y: 0,
            onComplete: p => {
              this._particulesContainer.removeChild(p);
              p.destroy({
                children: true
              });
            },
            onCompleteParams: [p]
          });
        },
        onCompleteParams: [particule],
        ease: "none"
      });
    }
  }
}
